import React from 'react';
import cn from 'bem-cn';

import { Stack } from '../Stack/Stack';
import { ImageWithFadeIn } from '../ImageWithFadeIn';

import { sanitize } from '../../../utils/sanitize/sanitize';

import { BannerProps } from './Banner.types';
import './Banner.scss';

const b = cn('banner');

export const Banner: React.FC<BannerProps> = ({ text, image, onClick }) => {
    const sanitizedHtml = sanitize(text);

    return (
        <Stack
            className={b({ clickable: Boolean(onClick) })}
            spacing={8}
            direction="row"
            alignItems="center"
            onClick={onClick}
        >
            <span className={b('text')} dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />
            {image && <ImageWithFadeIn src={image} alt="" className={b('image')} />}
        </Stack>
    );
};
